import { useInfiniteListWithRestore } from '../useInfiniteListWithRestore/useInfiniteListWithRestore';
import useMassActions from '../useMassActions/useMassActions';
import { UseInfiniteListWithCheckboxParams } from './useInfiniteListWithCheckbox.types';

export const useInfiniteListWithCheckbox = <PageData>({
  limit,
  queryFn,
  cacheKey,
  isEnabled,
  queryFnParams,
  defaultOrderBy,
}: UseInfiniteListWithCheckboxParams<PageData>) => {
  const checkboxManager = useMassActions<string>();

  const { mutateMethods, query, restoreScrollOnMount } = useInfiniteListWithRestore<PageData>({
    limit,
    isEnabled,
    defaultOrderBy,
    queryFn: (context) => queryFn({ ...context, params: queryFnParams }),
    queryKey: ['infinite-list-with-checkbox', cacheKey, queryFnParams],
  });

  return {
    query,
    mutateMethods,
    checkboxManager,
    restoreScrollOnMount,
  };
};
